export const DRAWER_WIDTH = 260;
export const CONTENT_MAX_WIDTH = 1280;
export const DRAWER_ITEM_LOBBY_TEXT = 'Membership required';
